//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import coutDown from './vue2-countdown'
import { nowInDateBetwen } from '@/libs/utils'
import {
  getView
} from '@/api/youzheng'
export default {
  components: {
    coutDown
  },
  data () {
    return {
      partyid: this.$route.params.artid,
      obj: {},
      startTime: '',
      endTime: '',
      currentTime: new Date().getTime(),
      status: 0, // 1征集，2投票活动
      tipText: '',
      tipTextEnd: '',
      endText: ''
    }
  },
  created () {
    this.view()
  },
  methods: {
    // 获取用户抽奖信息
    view () {
      getView({
        id: this.partyid
      }).then(res => {
        this.obj = res.obj
        this.getStatus()
      })
    },
    getStatus () {
      let status1 = nowInDateBetwen( // 0还未开始，1正在进行，-1结束
        this.obj.collectstartdate,
        this.obj.collectenddate
      )
      let status2 = nowInDateBetwen( // 0还未开始，1正在进行，-1结束
        this.obj.votestartdate,
        this.obj.voteenddate
      )
      if (status1 === 0 || status1 === 1 || (status1 === -1 && status2 === 0)) {
        this.status = 1
        this.tipText = '距离征集开始还有'
        this.tipTextEnd = '距离征集结束还有'
        this.endText = '征集已结束'
        this.startTime = this.obj.collectstartdate.replace(/-/g, '/')
        this.endTime = this.obj.collectenddate.replace(/-/g, '/')
        if (this.$route.name === 'fathersdayList' || this.$route.name === 'fathersdayMain') {
          this.$router.replace({ name: 'fathersdayIndex' })
        }
      } else if (status2 === 1 || status2 === -1) {
        this.status = 2
        this.tipText = '距离投票开始还有'
        this.tipTextEnd = '距离投票结束还有'
        this.endText = '投票已结束'
        this.startTime = this.obj.votestartdate.replace(/-/g, '/')
        this.endTime = this.obj.voteenddate.replace(/-/g, '/')
        if (this.$route.name === 'fathersdayIndex' || this.$route.name === 'fathersdayMain') {
          this.$router.replace({ name: 'fathersdayList' })
        }
      }
    }
  },
  watch: {
    '$route.name' () {
      this.getStatus()
    }
  }
}
